/*
 *
 * Package: `@dbh/app`.
 *
 */const importApp=import('./component-47af8193.js'/*  webpackChunkName: 'dbh.app.component' */);const importAppSsr=import('./ssr-9fd1d6c2.js'/*  webpackChunkName: 'dbh.app.ssr' */);

export { importApp, importAppSsr };
